var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('top'),_vm._v("\n    酒店审核\n")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }